import { Config } from '../context';

const TagManager = require('react-gtm-module');

export const initTagManager = () => {
	if (window && !!window['__webskyEngineConfig']) {
		const config = window['__webskyEngineConfig'] as Config;

		if (!window['tagManagerCreated'] && !!config.global?.gtmId) {
			try {
				TagManager.initialize({
					gtmId: config.global.gtmId,
					dataLayer: {
						userProject: config.global.companyInfo?.iataCode
					}
				});

				window['tagManagerCreated'] = true;
			} catch (e) {
				console.error(e);
			}
		}
	}
};
